module.exports = __webpack_public_path__ + "static/media/ng-map.c2933c4f.png";